import { Button } from "@/components/molecules/buttons/button";
import useConsultantInvoices from "@/services/admin-services/query/useConsultantInvoices";
import { useParams } from "react-router-dom";
import Invoice from "../../consultants-vision-admin/statement/Invoice";
import { Label } from "@/components/atoms/texts/label";
import ArrowBack from "@mui/icons-material/ArrowBack";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useEffect, useRef, useState } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import Filter from "@/components/organisms/Filter";
import PrintInformationMessage from "@/components/organisms/feedback/PrintInformationMessage";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
// import { useDeleteConsultantInvoice } from "@/services/admin-services/mutations/useDeleteConsultantInvoice";
import EditBillsPanel from "@/components/macro-organisms/panels/panels-admin/Bills/EditBillsPanel";
import AddInvoicePanel from "@/components/macro-organisms/panels/panels-admin/Bills/AddInvoicePanel"; import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import { useTranslation } from "react-i18next";
import { Toaster } from "@/components/organisms/feedback/toaster";

import MultiSelectorComponent, { ContentType } from "@/components/macro-organisms/tabs/MultiSelectorComponent";
import { useInvoices } from "@/services/consultant-services/query/useInvoices";


export default function InvoicesTabUser({ setInvoiceTab, allYears, selectedYearParent, dataOwner }) {
    const { id } = useParams();
    const [t] = useTranslation("global");

    const [selectedClient, setSelectedClient] = useState();
    const [invoicesCopy, setInvoicesCopy] = useState();
    const [selectedYear, setSelectedYear] = useState(selectedYearParent);

    const { data :invoices, loading, error, refetch } = useInvoices(selectedYear);
    // const { deleteConsultantInvoice, loading: loadingDelete, error: errorDelete, data: dataDelete } = useDeleteConsultantInvoice();


useEffect(() => {

        if (selectedClient) {
            setInvoicesCopy(invoices.filter((item) => {
                console.log("item.clientName", item.clientName, "selectedClient", selectedClient);
                console.log("item.clientName == selectedClient", item.clientName == selectedClient);
                return (item.clientName == selectedClient);

            }));
            console.log("invoicesCopy", invoicesCopy);
        } else {
            setInvoicesCopy(invoices);
        }
    }, [selectedClient, invoices]);

    useEffect(() => {
        invoicesCopy && console.log("invoicesCopy", invoicesCopy);
    }, [invoicesCopy]);

    // useEffect(() => {
    //     refetch();
    // }, [dataDelete]);


    return (
        <div className="flex flex-col  gap-secondDegree overflow-auto pb-secondDegree px-1 items-center">
            <Toaster />
            <div className="flex gap-secondDegree items-center w-full justify-between">
                <Button showLeftIcon leftIcon={<ArrowBack />} text="global.actions.return" onClick={() => setInvoiceTab(false)} style="outline" />
                <div className="grow flex items-center justify-center ml-[8%] gap-firstDegree">
                    <Label size="h4" fontWeight="bold" className="">Détails des factures</Label>
                    <Button style="ghost" disabled={loading} showLeftIcon leftIcon={<ReplayRoundedIcon />} onClick={() => refetch()} showText={false} sizePadding={"firstDegree"} />

                </div>
                <div className="flex gap-firstDegree items-center">
                    {/* <EditBillsPanel changeContent={true} disabledDeletion/> */}
                    {/* {dataOwner && <AddInvoicePanel refetch={refetch} dataOwner={dataOwner}/>}  */}


                    {selectedClient && <ClearIcon fontSize="small" onClick={() => setSelectedClient(null)} />}
                    <Select onValueChange={setSelectedClient} value={selectedClient}>
                        <SelectTrigger className="w-[180px] p-firstDegree">
                            <SelectValue placeholder={<Label message="global.actions.filterByClient" />}>
                                <Label>{selectedClient || t("global.actions.filterByClient")}</Label>
                            </SelectValue>
                        </SelectTrigger>
                        <SelectContent>
                            {Array.from(new Set(invoices.map((item) => item.clientName))).map((clientName, index) => (
                                <SelectItem key={index} value={clientName}>
                                    <Label>{clientName}</Label>
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>

            </div>



            <Filter
                items={allYears && allYears}
                informSelectedItem={setSelectedYear}
                defaultSelectedItem={selectedYear}
            />
            {loading && <span className="loader" />}
            {error && <PrintErrorMessage error={error} />}

            {!loading && 
                (invoicesCopy?.length === 0 ?
                    <PrintInformationMessage information={"consultants.statement.invoices.emptyData"} />
                    :
                    invoicesCopy?.map((item, index) => (
                        <Invoice key={item.uuid} data={item} deleteConsultantInvoice={() => { }} dataOwner={false} />

                    )))
            }

            {/* {invoicesCopy?.map((item, index) => (
                // 
                <Invoice key={item.uuid} data={item} dataOwner={false} />

            ))} */}
            {/* {loadingDelete && <span className="loader" />} */}




        </div>
    )
}
